import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Loads the Meta Pixel and fires a single PageView event.
 */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    if (!pixelId) return

    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
        } else {
          fbq.queue.push(args)
        }
      }
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq
      window._fbq = fbq

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')

    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      noscript.remove()
    }
  }, [pixelId])
}
